import script from "./VoicesMenuView.vue?vue&type=script&setup=true&lang=js"
export * from "./VoicesMenuView.vue?vue&type=script&setup=true&lang=js"

import "./VoicesMenuView.vue?vue&type=style&index=0&id=18a8c092&scoped=true&lang=css"

import exportComponent from "/Users/henry/ionic/verbalchess_ionic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18a8c092"]])

export default __exports__